import PromoBannerBento from "@/components/PromoBanner/variants/Bento";
import PromoBannerCard from "@/components/PromoBanner/variants/Card";
import PromoBannerCompactPlainText from "@/components/PromoBanner/variants/CompactPlainText";
import PromoBannerCompact from "@/components/PromoBanner/variants/Compact";
import PromoBannerCompress from "@/components/PromoBanner/variants/Compress";
import PromoBannerDefault from "@/components/PromoBanner/variants/Default";
import PromoBannerSimple from "@/components/PromoBanner/variants/Simple";
import PromoBannerSlim from "@/components/PromoBanner/variants/Slim";
import PromoBannerSplit from "@/components/PromoBanner/variants/Split";
import PromoBannerSlimWider from "@/components/PromoBanner/variants/SlimWider";
import PromoBannerSlimTagged from "@/components/PromoBanner/variants/SlimWiderTagged";
import type { PromoBannerProps } from "@/components/PromoBanner/types";

export default function PromoBanner({
  variant = "default",
  ...props
}: PromoBannerProps) {
  switch (variant) {
    case "bento":
      return <PromoBannerBento {...props} />;
    case "compact":
      return <PromoBannerCompact {...props} />;
    case "compactPlainText":
      return <PromoBannerCompactPlainText {...props} />;
    case "compress":
      return <PromoBannerCompress {...props} />;
    case "card":
      return <PromoBannerCard {...props} />;
    case "simple":
      return <PromoBannerSimple {...props} />;
    case "slim":
      return <PromoBannerSlim {...props} />;
    case "split":
      return <PromoBannerSplit {...props} />;
    case "slimWider":
      return <PromoBannerSlimWider {...props} />;
    case "slimTagged":
      return <PromoBannerSlimTagged {...props} />;
    case "countdown": // @todo implement countdown variant
    case "default":
    default:
      return <PromoBannerDefault {...props} />;
  }
}
